module.exports = __webpack_public_path__ + "static/media/motorbike.1768ad70.png";